import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { PlusCircleIcon } from 'lucide-react'
import { Title } from '@mantine/core'
import { Button } from '@/shared/ui/Button/Button'
import { DefaultManagerTable } from './ui/DefaultManagerTable/DefaultManagerTable'
import { ChangeDefaultManagerModal } from './ui/Modals/ChangeDefaultManagerModal'

export const DefaultManagerView = () => {
  const { t } = useTranslation(['common'])
  const [isOpenChangeModal, setOpenChangeModal] = useState(false)

  return (
    <div className='flex flex-col mb-5 md:w-full w-[calc(100%+2.5rem)] md:mx-0 mx-[-1.25rem] bg-white rounded-[1.25rem] shadow-navbar p-4'>
      <Title className='pb-5' order={4}>
        {t('common:library_items.default_manager.title')}
      </Title>
      <DefaultManagerTable
        addButtonSlot={
          <Button
            variant='primary'
            color='base'
            size='md'
            onClick={() => setOpenChangeModal(true)}
            leftIcon={<PlusCircleIcon size={16} />}
          >
            {t('common:library_items.default_manager.change_manager')}
          </Button>
        }
      />
      <ChangeDefaultManagerModal
        dialogProps={{ open: isOpenChangeModal, onOpenChange: setOpenChangeModal }}
        onCloseModal={() => setOpenChangeModal(false)}
      />
    </div>
  )
}
